import React, {useMemo} from 'react'
import {MainStore} from 'src/store/MainStore'

export const mainStoreContext = React.createContext<MainStore | null>(null)

export default function MainStoreProvider({children}: any) {
  const store = useMemo(() => new MainStore(), [])
  return (
    <mainStoreContext.Provider value={store}>
      {children}
    </mainStoreContext.Provider>
  )
}

export const useMainStore = () => {
  const store = React.useContext(mainStoreContext)
  if (!store)
    throw new Error('useStore must be used within a MainStoreProvider.')
  return store
}
